import {
  INITIAL_ERROR_STATE,
  REQUEST_STATUSES,
} from "../../../packages/constants";
import { AUTH_ENDPOINT_NAMES } from "../types";
import type { State } from "../types";

export const initialState: State = {
  requestStatuses: {
    [AUTH_ENDPOINT_NAMES.AUTH]: REQUEST_STATUSES.PENDING,
  },
  errorMessages: {
    [AUTH_ENDPOINT_NAMES.AUTH]: INITIAL_ERROR_STATE,
  },
  user: {
    id: "",
    name: {
      first: "",
      last: "",
      middle: "",
    },
  },
  access: {
    token: "",
    expired: 0,
  },
};
